import { useRecoilState } from 'recoil';

import { disabledChannels } from '../atoms/disabledChannels';

export default function useDisabledChannels() {
  return useRecoilState(disabledChannels);
}
